import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/QualityCertifications.css';
import QuoteModal from './QuoteModal';
import isoIcon from '../assets/01_ISO.png';
import cdscoIcon from '../assets/02_MEDICAL.png';
import md42Icon from '../assets/03_MEDICAL.png';
import msmeIcon from '../assets/04_MSME.png';
import dpiitIcon from '../assets/05_DPIIT.png';
import startupIndiaIcon from '../assets/06_STARTUP.png';


const QualityCertifications = () => {
  const navigate = useNavigate();
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const openQuoteModal = () => {
    setIsQuoteModalOpen(true);
  };

  const closeQuoteModal = () => {
    setIsQuoteModalOpen(false);
  };

  const handleScheduleTour = () => {
    navigate('/contact');
  };

 const certifications = [
  {
    id: 1,
    name: 'ISO 13485:2016',
    title: 'Medical Devices Quality Management System',
    description:
      'INTERNATIONAL QUALITY MANAGEMENT STANDARD FOR MEDICAL DEVICE MANUFACTURING.',
    icon: isoIcon,
    badge: 'Certified',
    color: '#1a73e8'
  },
  {
    id: 2,
    name: 'CDSCO MD-5',
    title: 'Medical Device Manufacturing Licence',
    description:
      'REGULATORY MANUFACTURING LICENCE FOR SPECIFIED MEDICAL DEVICES IN INDIA.',
    icon: cdscoIcon,
    badge: 'Licensed',
    color: '#e8710a'
  },
  {
    id: 3,
    name: 'MD-42',
    title: 'Medical Device Registration Certificate',
    description:
      'REGISTRATION CERTIFICATE FOR THE SALE, STOCKING, EXHIBITION OR DISTRIBUTION OF MEDICAL DEVICES.',
    icon: md42Icon,
    badge: 'Registered',
    color: '#2ecc71'
  },
  {
    id: 4,
    name: 'MSME',
    title: 'Micro, Small & Medium Enterprises',
    description:
      'UDYAM REGISTRATION UNDER THE GOVERNMENT OF INDIA MSME FRAMEWORK.',
    icon: msmeIcon,
    badge: 'Registered',
    color: '#9b59b6'
  },
  {
    id: 5,
    name: 'DPIIT',
    title: 'Department for Promotion of Industry and Internal Trade',
    description:
      'GOVERNMENT OF INDIA RECOGNITION UNDER THE STARTUP INDIA INITIATIVE.',
    icon: dpiitIcon,
    badge: 'Recognized',
    color: '#3498db'
  },
  {
    id: 6,
    name: 'STARTUP INDIA',
    title: 'Government of India Startup Initiative',
    description:
      'PART OF INDIA’S STARTUP ECOSYSTEM, SUPPORTING INNOVATION AND ENTREPRENEURSHIP.',
    icon: startupIndiaIcon,
    badge: 'Recognized',
    color: '#ff9933'
  }
];

  const qualitySeals = [
    {
      id: 1,
      title: 'Quality Assured',
      description: 'Each product undergoes rigorous quality checks',
      icon: '✓',
      color: '#d8bf8b'
    },
    {
      id: 2,
      title: 'ISO Certified Facility',
      description: 'Manufacturing facility with international standards',
      icon: '🏭',
      color: '#d8bf8b'
    },
    {
      id: 3,
      title: '100% Tested',
      description: 'Every unit tested before dispatch',
      icon: '🔬',
      color: '#d8bf8b'
    },
    {
      id: 4,
      title: '5-Point Quality Check',
      description: 'Multi-stage quality control process',
      icon: '✅',
      color: '#d8bf8b'
    }
  ];

 

  return (
    <>
      <section id="quality-certifications" className="quality-certifications-section">
        <div className="quality-certifications-container">
          
          {/* Section Header */}
          <div className="quality-certifications-header">
            <span className="quality-certifications-tagline">Quality Assurance</span>
            <h2 className="quality-certifications-title">
              Certifications & <span className="quality-certifications-highlight">Standards</span>
            </h2>
            <div className="quality-certifications-underline"></div>
            <p className="quality-certifications-subtitle">
              We are committed to delivering the highest quality hearing aids that meet 
              international standards and certifications.
            </p>
          </div>

          {/* Certifications Grid */}
          <div className="quality-certifications-grid">
            {certifications.map((cert) => (
              <div key={cert.id} className="quality-certification-card">
                <div className="quality-certification-icon" style={{ background: `${cert.color}15` }}>
                  <img src={cert.icon} alt={cert.name} />
                </div>
                <div className="quality-certification-content">
                  <div className="quality-certification-badge" style={{ background: cert.color }}>
                    {cert.badge}
                  </div>
                  <h3 className="quality-certification-name">{cert.name}</h3>
                  <p className="quality-certification-title">{cert.title}</p>
                  <p className="quality-certification-description">{cert.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Quality Seals Section */}
          <div className="quality-seals-section">
            <div className="quality-seals-header">
              <h3>Quality Assurance Seals</h3>
              <p>Our commitment to quality at every step</p>
            </div>
            <div className="quality-seals-grid">
              {qualitySeals.map((seal) => (
                <div key={seal.id} className="quality-seal-card">
                  <div className="quality-seal-icon">{seal.icon}</div>
                  <div>
                    <h4>{seal.title}</h4>
                    <p>{seal.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

         
         

          

          {/* CTA Section */}
          <div className="quality-certifications-cta">
            <div className="quality-certifications-cta-content">
              <h3>Quality You Can Trust</h3>
              <p>Partner with a manufacturer who prioritizes quality at every stage</p>
              <div className="quality-certifications-cta-buttons">
                <button onClick={openQuoteModal} className="quality-certifications-cta-primary">
                  Request Quality Documentation
                  <svg className="quality-certifications-cta-icon" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <button onClick={handleScheduleTour} className="quality-certifications-cta-secondary">
                  Schedule Facility Tour
                </button>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* Quote Modal */}
      <QuoteModal isOpen={isQuoteModalOpen} onClose={closeQuoteModal} />
    </>
  );
};

export default QualityCertifications;